import hcOffcanvasNav from 'hc-offcanvas-nav';

document.addEventListener('DOMContentLoaded', () => {

  const mainNav = document.querySelector('#main-nav');

  new hcOffcanvasNav(mainNav, {
    customToggle: '.nav-toggler',
  });

});

